export default __webpack_public_path__ + "static/media/UniLogo.229c2259.png";